import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IInvalidQuantityModalProps {
    show: boolean;
    handleHide: () => void;
    handleConfirm: () => void;
}

const InvalidQuantityModal: React.FC<IInvalidQuantityModalProps> = ({ show, handleHide, handleConfirm }) => {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={handleHide} centered>
            <Modal.Header className="border-0" closeButton>
                <h5 className="m-0">{t("Invalid quantity in stock")}</h5>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3 mx-0">
                    <Col xs="auto">
                        <div className="text-center">
                            {t(
                                "After saving the transaction, the quantity of the product in stock will become less than 0. Do you still want to save the transaction?"
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="g-2">
                    <Col xs={6}>
                        <Button variant="outline-primary" className="fw-normal w-100 rounded-1" onClick={handleHide}>
                            {t("Cancel")}
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button
                            type="submit"
                            variant="primary"
                            className="fw-bold w-100 rounded-1"
                            onClick={handleConfirm}
                        >
                            {t("Save")}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default InvalidQuantityModal;
